import React from "react";
import PropTypes from "prop-types";

import Modal from "../../common/Modal";

import CallDetailsForm from "../CallDetailsForm";

const CallDetailsModal = ({
  auth,
  call,
  codes,
  project,
  customer,
  contract,
  handleSave,
  handleClose,
  handleCancel,
  service,
  handleDelete,
  dates,
  saving,
  getServiceOptions
}) => (
  <Modal
    id="callDetailsModal"
    body={
      <CallDetailsForm
        auth={auth}
        call={call}
        codes={codes}
        project={project}
        contract={contract}
        service={service}
        customer={customer}
        onSave={handleSave}
        onCancel={handleCancel}
        onDelete={handleDelete}
        dates={dates}
        saving={saving}
        getServiceOptions={getServiceOptions}
      />
    }
    close={handleClose}
  />
);

CallDetailsModal.propTypes = {
  auth: PropTypes.object,
  call: PropTypes.object,
  codes: PropTypes.array,
  service: PropTypes.string,
  project: PropTypes.object,
  contract: PropTypes.object,
  customer: PropTypes.object,
  handleSave: PropTypes.func,
  handleClose: PropTypes.func,
  handleCancel: PropTypes.func,
  handleDelete: PropTypes.func,
  dates: PropTypes.array,
  saving: PropTypes.bool,
  getServiceOptions: PropTypes.func
};

export default CallDetailsModal;
